import React, { useState, useEffect, useRef } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './editViews.css';

import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes, _arrayBufferToBase64 } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import clip from './../../img/clip.png';
import home from './../../img/home.png';
import persons from './../../img/profile.png';
import car from './../../img/car.png';
import company from './../../img/company.png';
import crime from './../../img/crime.png';
import phoneInterner from './../../img/phoneInterner.png';
import event from './../../img/event.png';
import documents from './../../img/document.png';
import weapon from './../../img/weapon.png';
import bs from './../../img/bs.png';
import headPhone from './../../img/headphone.png';
import plus from './../../img/plus.png'
import minus from './../../img/minus.png'
import PersonModel from '../models/PersonModel';
import SearchModel from '../models/SearchModel';
import ModelForAdd from '../models/ModelForAdd';

import Person from '../components/Person';
import Address from '../components/Address';
import Company from '../components/Company';
import Auto from '../components/Auto';
import Contact from '../components/Contact';
import Document from '../components/Document';
import Gun from '../components/Gun';
import OPM from '../components/OPM';
import Traitor from '../components/Traitor';
import BS from '../components/BS';
import Kan from '../components/Kan';
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { Buffer } from 'buffer'
import {
    createChecker, createCheckerLabel, createCheckerInput,
    createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed,
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed,
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed,
    showError
} from '../ViewCreator';
import AddressModel from '../models/AddressModel';
import AutoModel from '../models/AutoModel';
import CompanyModel from '../models/CompanyModel';
import ContactModel from '../models/ContactModel';
import DocumentModel from '../models/DocumentModel';
import GunModel from '../models/GunModel';
import OPMModel from '../models/OPMModel';
import TraitorModel from '../models/TraitorModel';
import KanModel from '../models/KanModel';
import BSModel from '../models/BSModel';
import MyDropzone from '../components/MyDropzone';

var modelForAdd = (new ModelForAdd());
var personModel = (new PersonModel());
const cookies = new Cookies();
function ProceedingsEdit() {

    var searchModel = new SearchModel();

    const [isBlocked, setIsBlocked] = useState(false);

    const blockUI = () => {
        setIsBlocked(true);
    };

    const unblockUI = () => {
        setIsBlocked(false);
    };

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };

    const addNew = (id, type) => {
        
        clearPersonModel()
        if (type === 20000) {
            var per = new PersonModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.persons.push(per);
        } else if (type === 20001) {
            var per = new AddressModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.addresses.push(per);
        } else if (type === 20002) {
            var per = new AutoModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.auto.push(per);
        } else if (type === 20003) {
            var per = new CompanyModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.company.push(per);
        } else if (type === 20004) {
            var per = new ContactModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.contact.push(per);
        } else if (type === 20005) {
            var per = new DocumentModel()
            per.id = id
            personModel.documents.push(per);
        } else if (type === 20006) {
            var per = new GunModel()
            per.id = id
            personModel.gun.push(per);
        } else if (type === 20008) {
            var per = new OPMModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.opm.push(per);
        } else if (type === 20009) {
            var per = new TraitorModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.traitors.push(per);
        } else if (type === 20010) {
            var per = new KanModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.kan.push(per);
        } else if (type === 20011) {
            var per = new BSModel()
            per.id = id
            per.relStatus = 0
            per.relDesk = ""
            personModel.bs.push(per);
        } else if (type === 20012){
            var files = id
            for (let index = 0; index < files.length; index++) {
                const reader = new FileReader()
                reader.onabort = () => console.log('file reading was aborted')
                reader.onerror = () => console.log('file reading has failed')
                reader.onload = () => {
                // Do whatever you want with the file contents
                  const binaryStr = reader.result
                  var ex = "";
                  if (files[index].path == undefined) {
                    ex = files[index].name.split('.').pop().toLowerCase();
                  } else {
                    ex = files[index].path.split('.').pop().toLowerCase();
                  }
                  if (ex == 'bmp' || ex == 'gif' || ex == 'jpeg' || ex == 'jpg' || ex == 'tiff' || ex == 'png') {
                    var b = _arrayBufferToBase64(binaryStr)
                    var tt = {
                      image: b,
                      text: ""
                    }
                    personModel.photo.push(tt)
                    
                    
                  } else {
            
            
            
            
            
                    
                    var b = _arrayBufferToBase64(binaryStr)
            
            
            
            
                    
                    var tt = {
                      
                        fileName: files[index].name,
                        file: b,
                      
                      
                      text: "",
                      
                    }

                    
                      personModel.files.push(tt)
                    
                  }

                  sendReSave()
                }
                reader.readAsArrayBuffer(files[index])
              }
           
        } else if (type === 20013){
            var tt = {
                image: id,
                text: ""
              }
            personModel.photo.push(tt)
        }

        if (type !== 20012){
         sendReSave()
        }
    }

    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendPerson(id);
    }, []);

    const sendPerson = (id) => {
        var path = ip + '/api/proceedings/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                    
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    personModel = (pers)
                    setView(pers)

                }
            })
    }


    const eventSubmit = () => {
       
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }

    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id + "A")
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "AList").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "AList").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id + "A").value = l[index]
                            document.getElementById(id + "AList").innerHTML = "";



                            if(id=='typeProceedings'){
                        
                                personModel.typeProceedings = l[index]
                             }
                              
                              if(id=='numberProceedings'){
                                personModel.numberProceedings = l[index]
                                }
                              
                              if(id=='fabulaProceedings'){
                                personModel.fabulaProceedings = l[index]
                               }
        
                              if(id=='dateProceedings'){
                                personModel.dateProceedings = l[index]
                                }

                        }
                        document.getElementById(id + "AList").appendChild(z);

                    }
                }
            })








    }


    const fabulaProceedingschange = () => {
        personModel.fabulaProceedings = document.getElementById('fabulaProceedingsA').value
        changedfield('fabulaProceedings');
    }
    const dateProceedingschange = () => {
        personModel.dateProceedings = document.getElementById('dateProceedingsA').value
        changedfield('dateProceedings');
    }
    const numberProceedingschange = () => {
        personModel.numberProceedings = document.getElementById('numberProceedingsA').value
        changedfield('numberProceedings');
    }
    const typeProceedingschange = () => {
        personModel.typeProceedings = document.getElementById('typeProceedingsA').value
        changedfield('typeProceedings');
    }

    const handleFocus = (event) => {
        closeAllHelp()
    };

    const sendSave = () => {
        blockUI()
        var path = ip + '/api/proceedings/addData';

        personModel.persons = []
        personModel.addresses = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.documents = []
        personModel.gun = []
        personModel.opm = []
        personModel.photo = []
        personModel.files = []
        personModel.traitor = []

        if (personModel.typeProceedings == undefined || personModel.typeProceedings == ''){
            showError('Тип не може бути пустим')
            return;
          }
    
          if (personModel.numberProceedings == undefined || personModel.numberProceedings == ''){
            showError('Номер не може бути пустим')
            return;
          }
    
          if (personModel.dateProceedings == undefined || personModel.dateProceedings == ''){
            showError('Фабула не може бути пустою')
            return;
          }




        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                }
            })
    }

    const sendRemove = (inner) => {
        blockUI()
        var path = ip + '/api/proceedings/removeData';

        var bd = encryptAes(JSON.stringify(inner))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);
                    document.getElementById("addeditems").innerHTML = "";
                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const handleSubmit = (e) => {
        sendSave()

        e.preventDefault();
    }

    const sendReSave = () => {
        blockUI()
        var path = ip + '/api/proceedings/addData';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                unblockUI()
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)
                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    personModel = (result.data)
                    setView(result.data)

                }
            })
    }

    const sendOPMFullScreen = (id) => {
        window.open("/opm?id=" + id)
    }

    function clearPersonModel() {
        personModel.persons = []
        personModel.addresses = []
        personModel.auto = []
        personModel.company = []
        personModel.contact = []
        personModel.contacts = []
        personModel.documents = []
        personModel.gun = []
        personModel.guns = []
        personModel.opms = []
        personModel.opm = []
        personModel.photos = []
        personModel.photo = []
        personModel.files = []
        personModel.docs = []
        personModel.kan = []
        personModel.bs = []
        personModel.traitors = []
    }


    const changeSearch = (inner) => {

        var a = document.getElementById("foundItems");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            var z = document.createElement('div'); // is a node
            var vv = document.createElement('div');
            vv.className = "itemAddView"
            z.style.display = "table";
            vv.style.display = "table-cell";
            inner[index].style = "table-cell"
            var vb = document.createElement('div');
            vb.className = "itemAddButton"
            vb.innerHTML = "<img width=\"100%\" src=\"" + plus + "\"/>"
           

            if (document.getElementById("OPM").style.display == "block") {
                var temp = modelForAdd.opm
                const cl = i => () => {
                    var b = true;
                    for (let j = 0; j < modelForAdd.opm.length; j++) {
                        if (modelForAdd.opm[j].value.id == inner[index].value.id) {
                            b = false
                        }
                    }
                    if (b) {
                        clearPersonModel()
                        inner[index].value.relStatus = 0
                        inner[index].value.relDesk = ""
                        personModel.opm.push(inner[index].value);
                        sendReSave()
                        temp.push(inner[index])
                        changeAdded();
                    } else {
                        showError('Данний запис уже існує');
                    }
                }
                vb.onclick = cl(inner[index].value)
            }
            vv.appendChild(vb)
            z.appendChild(vv);
            z.appendChild(inner[index]);
            a.appendChild(z);

        }
    }

    const resetModel = () => {
        modelForAdd = new ModelForAdd()
    };

    const setView = (pers, obj) => {
        document.getElementById('typeProceedingsA').value = pers.typeProceedings
  document.getElementById('numberProceedingsA').value = pers.numberProceedings
  document.getElementById('fabulaProceedingsA').value = pers.fabulaProceedings
  document.getElementById('dateProceedingsA').value = pers.dateProceedings
        resetModel()
        if (pers.opms.length > 0) {

            for (let index = 0; index < pers.opms.length; index++) {
                addNewOPM(pers.opms[index], false)
                

            }
        }
        changeAdded()
    }

    const addNewOPM = (pers, isNewAdd = true) => {
        var z = document.createElement('div'); // is a node
        z.className = "listItem"
        var s = "<p align=\"left\">";
        var sn = (pers.numberOPM == undefined || pers.numberOPM == '' ? "" : pers.numberOPM + " ") +
            (pers.dateOPM == undefined || pers.dateOPM == '' ? "" : pers.dateOPM + " ");
        var sb = (pers.typeExecutor == undefined || pers.typeExecutor == '' ? "" : pers.typeExecutor + " ") +
            (pers.executor == undefined || pers.executor == '' ? "" : pers.executor + " ");
        var sc = (pers.ini_organ == undefined || pers.ini_organ == '' ? "" : pers.ini_organ + " ") +
            (pers.ini_direction == undefined || pers.ini_direction == '' ? "" : pers.ini_direction + " ") +
            (pers.ini_name == undefined || pers.ini_name == '' ? "" : pers.ini_name + " ");
        s += (sn == undefined || sn == '' ? "" : sn + "<br>") +
            (sb == undefined || sb == '' ? "" : sb + "<br>") +
            (sc == undefined || sc == '' ? "" : sc + "<br>");



        s += (pers.desc == undefined ? "" : pers.desc + "<br>");
        z.innerHTML = s
        z.style.display = "block";


        z.value = Object.assign({}, pers);

        var p = Object.assign({}, pers);

        if (p.numberOPM == undefined || p.numberOPM == '') {
            z.value = pers
            p = pers

        }

        if (p.numberOPM == undefined || p.numberOPM == '') {
            showError('Номер не може бути пустим')
            return;
        }

        if (p.dateOPM == undefined || p.dateOPM == '') {
            showError('Дата не може бути пустою')
            return;
        }

        if (p.typeExecutor == undefined || p.typeExecutor == '') {
            showError('Підрозділ виконавця не може бути пустим')
            return;
        }




        if (isNewAdd) {

            clearPersonModel()
            z.value.relStatus = 0
            z.value.relDesk = ""

            personModel.opm.push(z.value);

            sendReSave()
        } else {
            modelForAdd.opm.push(z)

            changeAdded()
        }
    }

    const changeAdded = () => {

        var a = document.getElementById("addeditems");
        a.innerHTML = ""

        if (document.getElementById("OPM").style.display == "block") {
            for (let index = 0; index < modelForAdd.opm.length; index++) {
                var z = document.createElement('div');
                z.className = "itemAddViewFull"
                var vv = document.createElement('div');
                vv.className = "itemAddView"
                z.style.display = "table";
                vv.style.display = "table-cell";
                modelForAdd.opm[index].style = "table-cell"
                var vb = document.createElement('div');
                vb.className = "itemAddButton"
                vb.innerHTML = "<img width=\"100%\" src=\"" + minus + "\"/>"
                const cl = i => () => {
                    Swal.fire({
                        title: 'Підтвердіть виделаення запису',
                        icon: 'question',
                        html: '',
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: 'Видалити',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                        if (result.isConfirmed) {
                        const queryParams = new URLSearchParams(window.location.search);
                        const id = queryParams.get("id");
                        var id2 = i.id
                        sendRemove([id, id2, 20007])
                        }
                    })
                }
                vb.onclick = cl(modelForAdd.opm[index].value)
               
                vv.appendChild(vb)
                z.appendChild(vv);
                var d = document.createElement('div');
                d.innerHTML = modelForAdd.opm[index].innerHTML;
                const dlcl = i => () => {
                    sendOPMFullScreen(i)
                 }
                 d.ondblclick = dlcl(modelForAdd.opm[index].value.id);
                z.appendChild(d);
                a.appendChild(z);
            }

        }
       
    }









    return (
        <div className="fixed inset-0 bg-black z-50">

            <div className="main">
                <div className="header">
                    <img src={logo} className="logo" alt="logo" />
                    <div className="title" onClick={mainSubmit}>SPACE</div>
                    <div className="subtitle">(edit) </div>

                </div>

                <div className="panel">


                    <button id="eventB" className="panelButtonActive-single" onClick={eventSubmit} >
                        <img src={event} className="panelImage" />
                    </button>
                    
                </div>

                <div className="searchMenu">

                    <form onSubmit={handleSubmit} className="form">


                        <input id="saveButton" className="input-button-right-proceedings" type="submit" value="Зберегти" />

                        <div id="fabulaProceedingsADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="fabulaProceedingsA" className="input-text" tabIndex="4" name="login" type="text" onChange={fabulaProceedingschange}  placeholder="Фабула" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="fabulaProceedingsAList" className="list" />
          </div>

          <div id="dateProceedingsADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="dateProceedingsA" className="input-text" tabIndex="3" name="login" type="text" onChange={dateProceedingschange}  placeholder="Дата" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="dateProceedingsAList" className="list" />
          </div>

          <div id="numberProceedingsADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="numberProceedingsA" className="input-text" tabIndex="2" name="login" type="text" onChange={numberProceedingschange}  placeholder="Номер" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="numberProceedingsAList" className="list" />
          </div>

          <div id="typeProceedingsADrop" className="dropdown-content" onKeyDown={handleKeyPress}>
            <input  id="typeProceedingsA" className="input-text" tabIndex="1" name="login" type="text" onChange={typeProceedingschange}  placeholder="Тип справи" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
            <div id="typeProceedingsAList" className="list" />
          </div>


                    </form>

                </div>

                <div className="searc2hMenu" >
                   
                    <div id="OPM" className="menuItems" style={{ display: "block" }}>
                        <OPM changeSearch={changeSearch} searchModel={searchModel} setView={setView} addNew={addNew} isAdd={true}/>
                    </div>
                   

                </div>


                <table width="100%" style={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }} >
                    <tbody>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="addeditems">

                            </div>
                        </td>
                        <td id="tdline" style={{ width: "1px", maxWidth: "1px", overflow: "hidden" }}>
                            <div id="line">

                            </div>
                        </td>
                        <td style={{ width: "600px", maxWidth: "600px", overflow: "hidden", wordWrap: "break-word" }}>
                            <div id="foundItems">

                            </div>
                        </td>
                        <td style={{ width: "350px", maxWidth: "350px", overflow: "hidden", whiteSpace: "nowrap" }}>

                        </td>
                        
                    </tbody>
                </table>
            </div>

            ({isBlocked && <div className={`black ${isBlocked ? "show" : ""}`}>
                <img src={loading} alt="logo" />

            </div>
            })
        </div>

    );
}


export default ProceedingsEdit;